import { AUTO_REFRESH_MS, PAGE_SIZE } from './config.js';

export const state = {
  rows: [],
  filtered: [],
  filters: {
    desde: '',
    hasta: '',
    search: '',
    statuses: new Set(),
    metaStatus: '',
    ctwa: '',
    metaMode: '',
  },
  sort: { col: 'FECHA', dir: 'desc' },
  page: 1,
  pageSize: PAGE_SIZE,
  grain: 'week',
  chart: null,
  autoRefreshMs: AUTO_REFRESH_MS,
  autoRefreshTimer: null,
  isLoading: false,
  lastSignature: '',
  firstLoad: true,
  // Hojas de VENTAS detectadas en runtime (poblada por sheetSelector tras el
  // discovery). La usa loadData() cuando el modo activo es '__ALL__' para
  // hacer fetch en paralelo. Excluye la hoja de costos.
  knownSheets: [],
  // Referencia a la hoja COSTOS/GASTOS si existe ({name, gid} | null).
  // La usa la vista "Datos Generales".
  costsSheet: null,
  metaSummary: { sent: 0, pending: 0, failed: 0, blocked: 0, missingCtwaClid: 0, test: 0 },
  reconciliationReport: { reconciled: 0, webhookOnly: 0, unmatchedSheets: 0, ambiguous: 0 },
  metaBackendConfigured: false,
};

export function rowSignature() {
  return state.rows.length + '|' + state.rows.map((r) =>
    [
      r.STATUS || '',
      r.FECHA ? r.FECHA.getTime() : 0,
      r.MONTO,
      r.NUMERO || '',
      r.EMAIL || '',
      r.SOURCE || '',
      r.EVENT_ID || '',
      r.DELIVERY_ID || '',
      r.CTWA_CLID || '',
      String(r.CTWA_PRESENT ?? ''),
      r.META_STATUS || '',
      r.META_MODE || '',
      r.META_ATTEMPTS ?? '',
      r.META_LAST_ATTEMPT || '',
      r.META_SENT_AT || '',
      r.META_ERROR_CODE || '',
      r.META_ERROR_MESSAGE || '',
    ].join(':')
  ).join('~');
}
